/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 49c2bd78a8e2
 */

import { CloudinaryAssetMgmtCore } from "../core.js";
import { encodeFormQuery, encodeSimple } from "../lib/encodings.js";
import { compactMap } from "../lib/primitives.js";
import { safeParse } from "../lib/schemas.js";
import { RequestOptions } from "../lib/sdks.js";
import { extractSecurity, resolveGlobalSecurity } from "../lib/security.js";
import { pathToFunc } from "../lib/url.js";
import { DirectionEnum } from "../models/directionenum.js";
import { APIError } from "../models/errors/apierror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import {
  SearchFoldersRequest,
  SearchFoldersRequest$zodSchema,
} from "../models/searchfoldersop.js";
import { APICall, APIPromise } from "../types/async.js";
import { Result } from "../types/fp.js";

/**
 * Searches for folders whose attributes match a given expression
 *
 * @remarks
 * Lists the folders that match the specified search expression. Limited to 2000 results. If no parameters are passed, returns the 50 most recently created folders in descending order of creation time.
 */
export function foldersSearchFolders(
  client$: CloudinaryAssetMgmtCore,
  expression?: string | undefined,
  sort_by?: Array<{ [k: string]: DirectionEnum }> | undefined,
  max_results?: number | undefined,
  next_cursor?: string | undefined,
  options?: RequestOptions,
): APIPromise<
  Result<
    Response,
    | APIError
    | SDKValidationError
    | UnexpectedClientError
    | InvalidRequestError
    | RequestAbortedError
    | RequestTimeoutError
    | ConnectionError
  >
> {
  return new APIPromise($do(
    client$,
    expression,
    sort_by,
    max_results,
    next_cursor,
    options,
  ));
}

async function $do(
  client$: CloudinaryAssetMgmtCore,
  expression?: string | undefined,
  sort_by?: Array<{ [k: string]: DirectionEnum }> | undefined,
  max_results?: number | undefined,
  next_cursor?: string | undefined,
  options?: RequestOptions,
): Promise<
  [
    Result<
      Response,
      | APIError
      | SDKValidationError
      | UnexpectedClientError
      | InvalidRequestError
      | RequestAbortedError
      | RequestTimeoutError
      | ConnectionError
    >,
    APICall,
  ]
> {
  const input$: SearchFoldersRequest | undefined = {
    expression: expression,
    sort_by: sort_by,
    max_results: max_results,
    next_cursor: next_cursor,
  };

  const parsed$ = safeParse(
    input$,
    (value$) => SearchFoldersRequest$zodSchema.optional().parse(value$),
    "Input validation failed",
  );
  if (!parsed$.ok) {
    return [parsed$, { status: "invalid" }];
  }
  const payload$ = parsed$.value;
  const body$ = null;

  const pathParams$ = {
    cloud_name: encodeSimple("cloud_name", client$._options.cloud_name, {
      explode: false,
      charEncoding: "percent",
    }),
  };
  const path$ = pathToFunc("/v1_1/{cloud_name}/folders/search")(
    pathParams$,
  );
  const query$ = encodeFormQuery({
    "expression": payload$?.expression,
    "max_results": payload$?.max_results,
    "next_cursor": payload$?.next_cursor,
    "sort_by": payload$?.sort_by,
  });

  const headers$ = new Headers(compactMap({
    Accept: "application/json",
  }));
  const securityInput = await extractSecurity(client$._options.security);
  const requestSecurity = resolveGlobalSecurity(securityInput);

  const context = {
    options: client$._options,
    baseURL: options?.serverURL ?? client$._baseURL ?? "",
    operationID: "searchFolders",
    oAuth2Scopes: null,
    resolvedSecurity: requestSecurity,
    securitySource: client$._options.security,
    retryConfig: options?.retries
      || client$._options.retryConfig
      || { strategy: "none" },
    retryCodes: options?.retryCodes || [
      "429",
      "500",
      "502",
      "503",
      "504",
    ],
  };

  const requestRes = client$._createRequest(context, {
    security: requestSecurity,
    method: "GET",
    baseURL: options?.serverURL,
    path: path$,
    headers: headers$,
    query: query$,
    body: body$,
    userAgent: client$._options.userAgent,
    timeoutMs: options?.timeoutMs || client$._options.timeoutMs
      || -1,
  }, options);
  if (!requestRes.ok) {
    return [requestRes, { status: "invalid" }];
  }
  const req$ = requestRes.value;

  const doResult = await client$._do(req$, {
    context,
    errorCodes: [],
    retryConfig: context.retryConfig,
    retryCodes: context.retryCodes,
  });
  if (!doResult.ok) {
    return [doResult, { status: "request-error", request: req$ }];
  }
  return [doResult, {
    status: "complete",
    "request": req$,
    response: doResult.value,
  }];
}
